// Save column preferences to localStorage (SSR-safe)
const saveColumnPreferences = ({ presetKey, columns }) => {
  if (typeof window === 'undefined') return;
  const data = {
    preset: presetKey,
    customColumns: columns,
    timestamp: new Date().toISOString()
  };
  localStorage.setItem('columnPreferences', JSON.stringify(data));
};
export default saveColumnPreferences;